import MainLayout, { CenteredContent } from './MainLayout';
import Register from '../components/Register';

const RegisterView = () => {
    return (
        <MainLayout>
            <CenteredContent>
                <Register />
            </CenteredContent>
        </MainLayout>
    );
};
export default RegisterView;
